<template>
  <hr />
  <div
    class="flex flex-row space-x-2 text-2xl font-bold text-bright-gray dark:text-white lg:text-4xl"
  >
    <h2>{{ t("question.shareholders") }}</h2>
  </div>
  <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
    <Shareholder
      @remove="removePerson"
      v-for="person in people"
      :key="person.id"
      :person="person"
    />
    <li class="">
      <button
        @click.prevent="addNew()"
        type="button"
        class="relative block w-full h-full p-12 text-center border-2 border-gray-300 border-dashed rounded-lg hover:border-gray-400 focus:outline-none"
      >
        <svg
          class="w-12 h-12 mx-auto text-gray-400"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z"
          ></path>
        </svg>
        <span class="block mt-2 text-sm font-medium text-gray-900"></span>
      </button>
    </li>
  </ul>
</template>

<script>
import Shareholder from "./Shareholder";
import { useI18n } from "vue-i18n";

export default {
  name: "ShareholderList",
  components: { Shareholder },
  props: {
    people: {
      type: Array,
      default: [],
    },
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const removePerson = (person) => {
      emit("remove", person);
    };

    const addNew = () => {
      emit("add");
    };

    return {
      t,
      addNew,
      removePerson,
    };
  },
};
</script>

<style scoped></style>
